import React, { useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import AdminPage from '../../shared/AdminPage'
import { useGroupSearch, useGroupTypeSearch } from '../../../../../api/groups'
import SydButton from '../../../../commonDesign/Button'
import SydTabs from '../../../../commonDesign/SydTabs'
import ErrorDisplay from '../../../../molecules/ErrorDisplay'
import Loading from '../../../../molecules/Loading'
import { TagDetailsTab } from './TagDetails'
import { TagModal } from './TagOptionModal'
import { TagOptionsTab } from './TagOptionList'

export const useDetailStyles = makeStyles((theme) => ({
  groupsHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  detailsHeader: {
    display: 'flex',
    gap: '1rem',
    alignItems: 'center'
  },
  description: {
    fontWeight: '400',
    marginTop: '0px'
  },
  detailSection: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '1rem'
  },
  detailRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '2rem'
  },
  detailCol: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  detailStartRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '2rem'
  },
  detailStartCol: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '1rem'
  },
  groupMember: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    alignItems: 'flex-start'
  },
  submitCancelButtons: {
    display: 'flex',
    flexDirection: 'row',
    gap: '1rem'
  },
  kvpFields: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '2rem'
  },
  kvpList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  inputBtnContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '1.25rem'
  },
  customRowContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '1rem',
    width: '300px'
  }
}))
const TagDetails = () => {
  const params = useParams()
  const tagId = parseInt(params.tagId, 10) || 0
  const classes = useDetailStyles()
  const query = useMemo(() => {
    const memberSearch = {
      includes: {
        groupMembers: true
      },
      filters: {
        levelTypeId: [{
          op: 'eq',
          value: tagId
        }]
      }
    }
    const detailSearch = {
      includes: {
        groupMemberTypes: true
      },
      filters: {
        groupTypeId: [{
          op: 'eq',
          value: tagId
        }],
        memberLevelTypeIds: [{ op: 'exists' }]
      }
    }
    return { members: memberSearch, groupData: detailSearch }
  }, [tagId]
  )
  const tabs = {
    'group-type-details': {
      label: 'Details'
    },
    'group-table': {
      label: 'Tag Options'
    }
  }

  const { data: memberDetailsRawData, isLoading: memberLoading } = useGroupSearch(query.members)
  const { data: tagDetailsRawData, isLoading: detailsLoading } = useGroupTypeSearch(query.groupData)

  const tagDetailData = tagDetailsRawData?.data?.[0]
  const memberDetailsData = memberDetailsRawData?.data

  const [currentTab, setCurrentTab] = useState('group-type-details')
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedGroup, setSelectedGroup] = useState(null)
  const onAddClick = () => {
    setSelectedGroup({
      groupId: null,
      longName: '',
      shortName: '',
      description: '',
      colorField: '#000000',
      ordinal: 0
    })
    setModalOpen(true)
  }
  if (detailsLoading) return <Loading />
  if (!tagDetailData) return <ErrorDisplay error='Tag not found' soft />
  return (
    <AdminPage>
      <>
        <TagModal
          open={modalOpen}
          close={() => setModalOpen(false)}
          tag={selectedGroup}
          groupTypeId={tagId}
        />
        <>
          <h1 className='text-2xl font-bold mb-0'>
            {tagDetailData?.longName}
          </h1>
          <>
            <p className={classes.description}>
              #{tagDetailData.groupTypeId} <br />
              {tagDetailData?.description?.trim() || 'No Description'}
            </p>
          </>
          <SydTabs.Group
            tabOptions={tabs}
            onChange={(val) => setCurrentTab(val)}
            defaultValue={currentTab}
            key='user_batches_admin'
          >
            <SydTabs.Links
              tabsKey='user_batches_admin'
              rightAdornment={<SydButton size='md' variant='primary' icon='add' onClick={onAddClick}>Add Tag Option</SydButton>}
            />
          </SydTabs.Group>
          {currentTab === 'group-type-details' ? (
            <TagDetailsTab groupTypeId={tagId} tagDetailData={tagDetailData} detailsLoading={detailsLoading} />
          ) : currentTab === 'group-table' ? (
            <TagOptionsTab memberDetailsData={memberDetailsData} memberLoading={memberLoading} setSelectedGroup={setSelectedGroup} setModalOpen={setModalOpen} isClientSpecific={tagDetailData?.clientSpecific === 1} />
          ) : null}
        </>
      </>
    </AdminPage>
  )
}

export default TagDetails
